import { CUSTOMER_AGENT } from '../constants/RoutingTypes';
import RoutingRuleBase from './RoutingRuleBase';
class CustomerAgentRoutingRules extends RoutingRuleBase({
  '@type': CUSTOMER_AGENT,
  aiAgentId: null
}, 'CustomerAgentRoutingRules') {
  constructor(options) {
    const aiAgentId = (options === null || options === void 0 ? void 0 : options.aiAgentId) || null;
    super(options);
    return this.set('aiAgentId', aiAgentId);
  }
}
export const buildCustomerAgentRoutingRules = options => new CustomerAgentRoutingRules(options);